var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"system-publish"}},[_c('div',{staticClass:"ipub-h1 mar-b-20"},[_vm._v("Publisher")]),_c('site-tab',{staticClass:"mar-b-30",attrs:{"menus":_vm.menus}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }